import { IonContent, IonTextarea, IonHeader, IonButtons, IonBackButton, IonPage, IonTitle, IonToolbar, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonIcon, IonList, IonItem, IonButton, useIonAlert, IonAlert, useIonViewDidEnter, IonLabel, IonInput, IonToast, useIonToast, IonSelect, IonSelectOption, IonSpinner, IonFab, IonFabButton, IonFabList } from '@ionic/react';
import './tid.css';
import { people, checkmarkCircleOutline, closeCircleOutline, search, add, create, medkit, airplane } from 'ionicons/icons'
import getApi from '../api';
import EnvironmentBadge from '../components/EnvironmentBadge';
import { ChangeEvent, useEffect, useState } from 'react';
import { useLocalStorage } from '../components/useLocalStorage';
import notifications from '../components/Notifications';
import CustomerSearchModal from '../components/CustomerSearchModal';
import Box from '@mui/material/Box';
import { DataGrid, GridCellEditStopParams, GridCellEditStopReasons, GridColDef, MuiEvent, useGridApiRef, GridEventListener } from '@mui/x-data-grid';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import React from 'react';
import { useHistory } from "react-router-dom";


const Tid: React.FC = () => {

  const [presentAlert] = useIonAlert();
  let [Time, setTime] = useLocalStorage("time", "");
  let [TimeResult, setTimeResult] = useLocalStorage("timeresults", "");
  const [me, setMe] = useLocalStorage("me", "");
  const apiRef = useGridApiRef();
  const history = useHistory();
  const [present] = useIonToast();
  const [type, setType] = useState('ordernumber');
  const [description, setDescription] = useState('');
  const [orderId, setOrderId] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoadingExistingData, setIsLoadingExistingData] = useState(false);

  // State for order validation
  const [isOrderValid, setIsOrderValid] = useState<boolean | null>(null);
  const [isCheckingOrder, setIsCheckingOrder] = useState(false);
  const [orderError, setOrderError] = useState('');

  // Helper function to get check-in status (ant=0 means checked in, ant=1 means checked out)
  const isCheckedIn = () => {
    const timeObj = Time as any;
    // Check 'ant' first (new format), fall back to '0' (old format)
    return (timeObj['ant'] !== undefined ? timeObj['ant'] === 0 : timeObj['0'] === 0);
  };

  const handleSelectChange = (event: any) => {
    setType(event.target.value);
    // Reset validation when type changes
    setIsOrderValid(null);
    setOrderError('');
  };


  const api = getApi();

  const checkOrderExists = async (id: string) => {
    if (!id) return;

    setIsCheckingOrder(true);
    setIsOrderValid(null);
    setOrderError('');

    try {
      const response = await api.get(`/fortnox/orders/${id}/`);

      if (response.data.ErrorInformation && response.data.ErrorInformation.Message) {
        setIsOrderValid(false);
        setOrderError(response.data.ErrorInformation.Message);
      } else if (response.data.Order.Sent === true) {
        setIsOrderValid(false);
        setOrderError('Ordern är stängd och kan inte tidregistreras.');
      } else {
        setIsOrderValid(true);
      }

    } catch (error: any) {
      if (error.response && error.response.data && error.response.data.ErrorInformation && error.response.data.ErrorInformation.Message) {
        setIsOrderValid(false);
        setOrderError(error.response.data.ErrorInformation.Message);
      } else if (error.response && error.response.status === 404) {
        setIsOrderValid(false);
        setOrderError('Ordernumret kunde inte hittas.');
      } else {
        setIsOrderValid(false);
        setOrderError('Ett fel uppstod vid validering.');
        console.error("Order validation error:", error);
      }
    } finally {
      setIsCheckingOrder(false);
    }
  };

  // Debounced effect for order validation
  useEffect(() => {
    // Skip validation if we're loading existing data
    if (isLoadingExistingData) {
      return;
    }

    if (type === 'intern' || !orderId) {
      setIsOrderValid(null);
      setOrderError('');
      return;
    }

    // Clear previous validation state
    setIsOrderValid(null);
    const handler = setTimeout(() => {
      checkOrderExists(orderId);
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler);
    };
  }, [orderId, type, isLoadingExistingData]);

  useIonViewDidEnter(() => {
    setIsLoadingExistingData(true);
    api.get("/user/timeregister/?ordering=-date,-check_in&user="+me.id)
      .then(res => {
        console.log(res.data)
        setTimeResult(res.data)

        // Check if user is currently checked in based on backend data
        if (res.data.results && res.data.results.length > 0) {
          const latestEntry = res.data.results[0];
          
          // If check_out is null, user is currently checked in
          if (latestEntry.check_out === null) {
            // Update Time state to reflect checked in status (using 'ant' key like the API)
            setTime({
              'ant': 0,
              'time': latestEntry.check_in,
              'user': me.first_name + ' ' + me.last_name
            });
            setStartTime(latestEntry.check_in);
            
            setDescription(latestEntry.desc);
            setOrderId(latestEntry.order_id);
            // Set order as valid if already checked in (assume it was valid when checked in)
            if (latestEntry.order_id) {
              setIsOrderValid(true);
            }
          } else {
            // User is checked out, make sure Time state reflects this
            if ((Time as any)['ant'] === 0 || (Time as any)['0'] === 0) {
              setTime({'ant': 1, 'user': me.first_name + ' ' + me.last_name});
            }
          }
        }
        // Allow validation to run again after loading
        setTimeout(() => setIsLoadingExistingData(false), 100);
      })
      .catch(err => {
        console.error("Failed to load time registrations:", err);
        setIsLoadingExistingData(false);
      })

  });

  function time(){
    const text = description;
    const current_order_id = orderId;

    const data = new FormData();
    data.append('desc', text);
    data.append('order_id', current_order_id);

    if (isCheckedIn()) {
      check_out(text, current_order_id)
    }
    else {

      notifications.schedule(12,0,'BBE','Klockan är 12:00 dags för lunch?')
      notifications.schedule(17,0,'BBE','Du har en tidsregistrering som fortfarande är aktiv!')
      notifications.schedule(18,0,'BBE','Du har en tidsregistrering som fortfarande är aktiv!')
      notifications.schedule(19,0,'BBE','Du har en tidsregistrering som fortfarande är aktiv!')
      notifications.schedule(20,0,'BBE','Du har en tidsregistrering som fortfarande är aktiv!')
      api.post('/bbe/staff/check_in/', data)
      .then(function (response) {
        console.log(response);
        setTime(response.data)
        setStartTime((Time as any)['time']);
      })
      .catch(function (error) {
        console.log(error);

        presentAlert({
          message: 'Det gick inte att spara tiden!',
          buttons: ['OK'],
        })
      });
  }
  }

  function pause(){
    const text = description;
    const current_order_id = orderId;
    
    if (isCheckedIn()) {
      check_out_pause(text, current_order_id)
    }
    else {
      const data = new FormData();
      data.append('desc', text);
      data.append('order_id', current_order_id);

      notifications.schedule(12,0,'BBE','Klockan är 12:00 dags för lunch?')
      notifications.schedule(17,0,'BBE','Du har en tidsregistrering som fortfarande är aktiv!')
      notifications.schedule(18,0,'BBE','Du har en tidsregistrering som fortfarande är aktiv!')
      notifications.schedule(19,0,'BBE','Du har en tidsregistrering som fortfarande är aktiv!')
      notifications.schedule(20,0,'BBE','Du har en tidsregistrering som fortfarande är aktiv!')
      api.post('/bbe/staff/check_in/', data)
      .then(function (response) {
        console.log(response);
        setTime(response.data)
        setStartTime((Time as any)['time']);
      })
      .catch(function (error) {
        console.log(error);

        presentAlert({
          message: 'Det gick inte att spara tiden!',
          buttons: ['OK'],
        })
      });
  }
  }

  const [timeElapsed, setTimeElapsed] = useState('');
  const [startTime, setStartTime] = useState('');

  useEffect(() => {
    setStartTime((Time as any)['time']);
  }, []);

  useEffect(() => {
    if (!startTime) return;
    const intervalId = setInterval(() => {
      setTimeElapsed(getTimeElapsed());
    }, 1000);
    return () => clearInterval(intervalId);
  }, [startTime]);

  function pad(num: number) {
    return num.toString().padStart(2, '0');
  }

  function getTimeElapsed() {
    if (!startTime) return '';
    const now = new Date();
    const [startHours, startMinutes, startSeconds] = startTime.split(':').map(Number);
    const start = new Date();
    start.setHours(startHours, startMinutes, startSeconds);
    const diffInMs = now.getTime() - start.getTime();
    const diffInSec = Math.floor(diffInMs / 1000);
    const hoursDiff = Math.floor(diffInSec / 3600);
    const minutesDiff = Math.floor((diffInSec % 3600) / 60);
    const secondsDiff = diffInSec % 60;
    return `${pad(hoursDiff)}:${pad(minutesDiff)}:${pad(secondsDiff)}`;
    
  }

  function check_out(text: string, order_id: string) {
    if(type === 'intern' && !text) {
      present({ message: 'Du måste fylla i en beskrivning!', duration: 5000, position: 'top' });
      return;
    }

    if (type !== 'intern') {
      if (!order_id || !text) {
        present({ message: 'Du måste fylla i ordernummer och beskrivning!', duration: 5000, position: 'top' });
        return;
      }
      if (isOrderValid !== true) {
        present({ message: 'Ange ett giltigt ordernummer.', duration: 5000, position: 'top' });
        return;
      }
    }

    const data = new FormData();
    data.append('desc', text);
    data.append('order_id', order_id);

    api.post('/bbe/staff/check_in/', data)
    .then(function (response) {
      console.log(response);
      setTime(response.data)
      notifications.cancel();

      api.get("/user/timeregister/?ordering=-date,-check_in&user="+me.id)
      .then(res => {
        setDescription('');
        setOrderId('');
        setIsOrderValid(null);
        setOrderError('');

        console.log(res.data)
        setTimeResult(res.data)
      })

    })
    .catch(function (error) {
      console.log(error);
      if(error.response.data.ErrorInformation.Message){
        presentAlert({
          message: error.response.data.ErrorInformation.Message,
          buttons: ['OK'],
        })
      }
      else {
        presentAlert({
          message: 'Det gick inte att spara tiden!',
          buttons: ['OK'],
        })
      }
    });
  }

  function check_out_pause(text: string, order_id: string) {
    if(type === 'intern' && !text) {
      console.log('Order ID and text area may not be empty.');
      present({
        message: 'Du måste fylla i en beskrivning!',
        duration: 5000,
        position: 'top'
      });
    } else if ((!order_id || !text) && type !== 'intern') {
      console.log('Order ID and text area may not be empty.');
      present({
        message: 'Du måste fylla i ordernummer och beskrivning!',
        duration: 5000,
        position: 'top'
      });
      
  } else {

    const data = new FormData();
    data.append('desc', text);
    data.append('order_id', order_id);

    api.post('/bbe/staff/check_in/', data)
    .then(function (response) {
      console.log(response);
      setTime(response.data)
      notifications.cancel();

      setIsLoadingExistingData(true);
      api.get("/user/timeregister/?ordering=-date,-check_in&user="+me.id)
      .then(res => {
        console.log(res.data)
        setTimeResult(res.data)
        
        // Update description and orderId after pause/resume
        // Skip if it's a sick leave or vacation entry
        if (res.data.results && res.data.results.length > 0) {
          let latestEntry = res.data.results[0];
          
          // If first entry is sick leave or vacation, find the next regular entry
          if (latestEntry.desc === 'Semester' || latestEntry.desc === 'Sjukfrånvaro') {
            for (let i = 1; i < res.data.results.length; i++) {
              if (res.data.results[i].desc !== 'Semester' && res.data.results[i].desc !== 'Sjukfrånvaro') {
                latestEntry = res.data.results[i];
                break;
              }
            }
          }
          
          // Only update if it's not a sick leave or vacation entry
          if (latestEntry.desc !== 'Semester' && latestEntry.desc !== 'Sjukfrånvaro') {
            setDescription(latestEntry.desc);
            setOrderId(latestEntry.order_id);
            if (latestEntry.order_id) {
              setIsOrderValid(true);
            }
          }
        }
        setTimeout(() => setIsLoadingExistingData(false), 100);
      })

    })
    .catch(function (error) {
      console.log(error);
      if(error.response.data.ErrorInformation.Message){
        presentAlert({
          message: error.response.data.ErrorInformation.Message,
          buttons: ['OK'],
        })
      }
      else {
        presentAlert({
          message: 'Det gick inte att spara tiden!',
          buttons: ['OK'],
        })
      }
    });
  }
  }

  const columns: GridColDef[] = [
    {
      field: 'date',
      headerName: 'Datum',
      width: 120,
      minWidth: 120,
      editable: false,
      sortable: false,
      hideable: false
    },
    {
      field: 'hours',
      headerName: 'Tid',
      width: 70,
      minWidth: 70,
      editable: false,
      sortable: false,
      hideable: false
    },
    {
      field: 'desc',
      headerName: 'Beskrivning',
      minWidth: 300,
      flex: 1,
      editable: false,
      sortable: false,
      hideable: false
    },
  ];

  function Update(row: any) {
    const data = row;
    var id = row.id;
    delete row.check_in;
    delete row.date;
    delete row.hours;
    delete row.user;
    delete row.check_out;


    api.patch('/user/timeregister/'+id+'/', row)
    .then(function (response) {
      console.log(response);
    })
    .catch(function (error) {
      console.log(error);
    });

    return row;
  }

  const handleRowClick: GridEventListener<'rowClick'> = (params) => {
    console.log(`Row "${params.row.date}" clicked`);
    history.push('/Tid/'+params.row.id);
  };

  return (
    <ScopedCssBaseline enableColorScheme >
    <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonButtons slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonBackButton />
          </IonButtons>
          <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Tid</IonTitle>
          <div slot="end" style={{paddingRight:'8px'}}><EnvironmentBadge /></div>
        </IonToolbar>
      </IonHeader>
<IonContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonCardHeader color={isCheckedIn() ? 'success' : 'medium'} className="ion-text-center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonCardTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{isCheckedIn() ? 'INSTÄMPLAD' : 'UTSTÄMPLAD'}</IonCardTitle>
        </IonCardHeader>
        <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Tid startad:</IonCol>
                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{isCheckedIn() ? (Time as any)['time'] : ''}</IonCol>
                </IonRow>
                </IonItem>
                <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Arbetad tid:</IonCol>
                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <div className="timer-display">
                    {isCheckedIn() ? timeElapsed : '00:00:00'}
                  </div>
                </IonCol>
              </IonRow>
              </IonItem>
              <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonTextarea
                    id='textArea'
                    value={description}
                    onIonChange={e => setDescription(e.detail.value!)}
                    placeholder="Beskrivning av arbetet" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}                ></IonTextarea>
              </IonItem>
              <IonSelect id="type" interface="popover" placeholder="Ordernummer eller Internt" value={type} onIonChange={handleSelectChange} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonSelectOption value="ordernumber" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Ordernummer</IonSelectOption>
                <IonSelectOption value="intern" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Intern</IonSelectOption>
              </IonSelect>

              {type !== 'intern' && (
                <>
                  <IonItem lines="none" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonLabel position="stacked" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Ordernummer</IonLabel>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <IonInput
                        type="number"
                        value={orderId}
                        onIonChange={e => setOrderId(e.detail.value!)}
                        placeholder="Ange ordernummer"
                        className="order-input" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonInput>
                      <IonButton fill="clear" onClick={() => setIsModalOpen(true)} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} placeholder={undefined}>
                        <IonIcon icon={search} slot="icon-only" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} placeholder={undefined} />
                      </IonButton>
                      {isCheckingOrder && <IonSpinner name="crescent" className="validation-spinner" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} placeholder={undefined}></IonSpinner>}
                      {isOrderValid === true && <IonIcon icon={checkmarkCircleOutline} color="success" className="validation-icon" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} placeholder={undefined} />}
                      {isOrderValid === false && <IonIcon icon={closeCircleOutline} color="danger" className="validation-icon" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} placeholder={undefined} />}
                    </div>
                  </IonItem>
                  {orderError && (
                    <IonItem lines="none" className="error-message-item" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} placeholder={undefined}>
                      <IonLabel color="danger" className="ion-text-wrap" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} placeholder={undefined}>
                        {orderError}
                      </IonLabel>
                    </IonItem>
                  )}
                </>
              )}
            
          </IonList>
          <CustomerSearchModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSelectOrder={(selectedOrderId) => {
              setOrderId(selectedOrderId);
              setIsModalOpen(false);
            }}
          />

          <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton onClick={() => pause()} expand="block" color="warning" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{isCheckedIn() ? "Pausa" : "Återuppta"}</IonButton></IonCol>
              <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonButton
                  onClick={() => time()}
                  expand="block"
                  color={isCheckedIn() ? "danger" : "success"}
                  disabled={type === 'ordernumber' && isOrderValid !== true && isCheckedIn()}
                  placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    {isCheckedIn() ? "Stämpla ut" : "Stämpla in"}
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonCardContent>
      </IonCard>

      <IonCard placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        
          <Box sx={{ height: 650, width: '100%' }}>
            { TimeResult && <DataGrid
              onRowClick={handleRowClick}
              sx={{ color: '#000', backgroundColor: '#fff'}}
              rows={TimeResult.results}
              columns={columns}
              disableColumnFilter
              disableColumnMenu 
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
              }}
              processRowUpdate={(updatedRow, originalRow) =>
                Update(updatedRow)
              }
              onProcessRowUpdateError={console.error}

            /> }
          
          </Box>
        </IonCardContent>
      </IonCard>
      <IonFab slot="fixed" vertical="bottom" horizontal="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonFabButton placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonIcon icon={add} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
        </IonFabButton>
        <IonFabList side="top" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonFabButton 
            color="light"
            onClick={() => history.push('/TimeRegistration')}
            placeholder={undefined} 
            onPointerEnterCapture={undefined} 
            onPointerLeaveCapture={undefined}
          >
            Tidsregistrering
          </IonFabButton>
          <IonFabButton 
            color="light"
            onClick={() => history.push('/SickLeave')}
            placeholder={undefined} 
            onPointerEnterCapture={undefined} 
            onPointerLeaveCapture={undefined}
          >
            Sjukdag
          </IonFabButton>
          <IonFabButton 
            color="light"
            onClick={() => history.push('/Vacation')}
            placeholder={undefined} 
            onPointerEnterCapture={undefined} 
            onPointerLeaveCapture={undefined}
          >
            Semester
          </IonFabButton>
        </IonFabList>
      </IonFab>
      </IonContent>
    </IonPage>
    </ScopedCssBaseline>
  );
};

export default Tid;


